<template>
  <div class="content-container">
    <b-container fluid>
      <b-row class="pt-3">
        <b-col cols="12">
          <h1>{{job.name}}</h1>
        </b-col>
      </b-row>
      <b-row class="mt-3 pb-3">
        <b-col sm="12" md="6">
          <p class="mb-0">{{$t('jobDetails.inputLanguageLabel')}}: {{job.inputLanguage}}</p>
          <p class="mb-0">{{$t('jobDetails.desiredLanguageLabel')}}: {{job.desiredLanguage}}</p>
        </b-col>
        <b-col sm="12" md="6">
          <p class="mb-0">{{$t('jobDetails.statusLabel')}}: {{job.status}}</p>
          <p class="mb-0">{{$t('jobDetails.secondsUsedLabel')}}: {{job.secondsUsed}}</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: mapState({
      job: state => state.keywordAnalysis.keywordAnalysis.transcript.job,
    }),
  };
</script>

<style scoped>

</style>
